namespace TR {
    'use strict';

    //TODO: Decide what to do with this interface:
    interface GroupBookingOption {
        value: string|number;
        text: string;
    }

    class SpecialAssistance {
        model: any;
        departureDateMin: string;
        durationOfStayOptions: GroupBookingOption[];
        bookingTypeOptions: GroupBookingOption[];
        boardBasisOptions: string[];
        roomTypeOptions: string[];
        roomAdultsCountOptions: number[];
        roomChildrenCountOptions: number[];
        passengerCountAdultsOptions: number[];
        passengerCountChildrenOptions: number[];
        transferTypeOptions: string[];
        isTakingWheelchairOptions: string[];
        typeOfAssistanceOptions: string[];

        constructor(
            private $q: ng.IQService,
            private $location: ng.ILocationService,
            private $http: ng.IHttpService,
            private $timeout: ng.ITimeoutService,
            private $scope: any,
            private $rootScope: any,
            private filtering: any,
            private dateUtil: any,
            private scrollService: any,
            private funcUtil: any,
            private resourceService: Core.ResourceService
        ) {
            this.model = {
                rooms: [this['newRoom']()],
                bookingType: 'holiday',
                passengerCount: {
                    Adults: 1,
                    Teenagers: 0,
                    Children: 0,
                    Infants: 0,
                },
                durationOfStay: 7,
                isTakingWheelchair: 'No',
                typeOfAssistance: 'N/A',
            };
            this.departureDateMin = dateUtil.todayPlus(2);
            this.durationOfStayOptions = _.map(
                _.range(1, 41),
                i => ({
                    value: i,
                    text: i + ' ' + resourceService.get(i === 1 ? 'NIGHT' : 'NIGHTS')
                })
            );
            this.bookingTypeOptions = [
                { text: 'Flights Only', value: 'flight' },
                { text: 'Hotel Only', value: 'hotel' },
                { text: 'Flights + Hotel', value: 'holiday' },
            ];
            this.boardBasisOptions = [
                'Room Only', 'Bed & Breakfast', 'Half Board', 'Full Board', 'All Inclusive', 'Self Catering'
            ];
            this.roomTypeOptions = [
                'Single', 'Twin', 'Double', 'Triple', 'Studio', '1 Bedroom Apartment', '2 Bedroom Apartment'
            ];
            this.roomAdultsCountOptions = _.range(1, 7);
            this.roomChildrenCountOptions = _.range(0, 6);
            this.passengerCountAdultsOptions = _.range(1, 100);
            this.passengerCountChildrenOptions = _.range(0, 100);
            this.transferTypeOptions = ['Shuttle', 'Minibus', 'Taxis'];
            this.isTakingWheelchairOptions = ['Yes', 'No'];
            this.typeOfAssistanceOptions = [
                'N/A', 'Check In To Gate', 'Check In To Gate & Stairs', 'Check In To Seat'
            ];
        }

        newRoom() {
            return {
                roomType: 'Double',
                adults: 2,
                children: 0,
            };
        }

        isOccupancyValid() {
            if (this.model.bookingType === 'hotel' || this.model.bookingType === 'holiday') {
                if (this.model.rooms.length > 3) {
                    return true;
                }
            }
            if (this.model.bookingType === 'flight' || this.model.bookingType === 'holiday') {
                let pax = this.model.passengerCount.Adults + this.model.passengerCount.Teenagers +
                    this.model.passengerCount.Children + this.model.passengerCount.Infants;
                if (pax > 12) {
                    return true;
                }
            }
            return false;
        }

        onSubmit(form) {
            if (form.$valid) {
                let request = angular.copy(this.model);
                request.bookingType = _.find(this.bookingTypeOptions, o => o.value === request.bookingType).text;
                this['apiRequest'] = request;
            }
        }
    }

    angular
        .module('TR')
        .controller('specialAssistance', SpecialAssistance);
}
